<template>

    <form ref="tipoalvoatendimento-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="tipoAlvoAtendimentoId">ID</label>
                <input type="number" class="form-control" name="tipoAlvoAtendimentoId" placeholder="ID" v-model="model.tipoAlvoAtendimentoId" required />
            </div>

            <div class="form-group col-md-12">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="model.nome" required />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "tipoalvoatendimento-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "tipoalvoatendimento-form-create",

            resources: {
                create: 'tipoalvoatendimento',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

